/** Interface descriptor for instant catalog items */
interface ICatalogItem {
    CategoryID: number;
    Name: string;
    Image: string;
    ID?: number;
    Shop?: number;
    features?: [ // Prestashop feature values
        {
            name: string;
            value: string;
            id_feature: number;
            position: number;
            id_feature_value: number;
        }
    ]
    Children?: ICatalogItem[];
}

export default ICatalogItem;
